import React, { FC } from 'react'
import { Backdrop, StyledModal } from './styled'
import Box from '@mui/material/Box'
import theme from '../../theme'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

interface AppModalProps {
	readonly open: boolean
	readonly onClose: React.MouseEventHandler
	readonly title?: string
	children?: React.ReactNode
	width?: string
}

const AppModal: FC<AppModalProps> = ({
	open,
	onClose,
	title,
	children,
	width = '51.5rem',
}: AppModalProps) => {
	return (
		<StyledModal
			aria-labelledby='modal-title'
			aria-describedby='modal-description'
			open={open}
			onClose={onClose}
			BackdropComponent={Backdrop}
		>
			<Box
				width={width}
				bgcolor={'#fff'}
				borderRadius={'1rem'}
				overflow={'hidden'}
				my={'auto'}
			>
				<Box
					component={'header'}
					bgcolor={theme.palette.text.primary}
					py={4.8}
					px={6.75}
					color={theme.palette.common.white}
					display={'flex'}
					alignItems={'center'}
				>
					<Typography
						variant={'h6'}
						component={'h1'}
						flexGrow={1}
						textAlign={'center'}
					>
						{title}
					</Typography>

					<IconButton
						aria-label='close'
						size='large'
						onClick={onClose}
						sx={{ p: 0, color: theme.palette.common.white }}
					>
						<CloseIcon />
					</IconButton>
				</Box>

				{children}
			</Box>
		</StyledModal>
	)
}

export default AppModal
